import {SweetAlert} from '../../../../components/modals/SweetAlert'
import {TicketWaiverModel} from '../../../../models/digital-waiver/TicketWaiverModel'
import {TicketSubmitWaiverFormEdit} from '../waiverForms'
import {ENGLISH_CONTENT, ARABIC_CONTENT} from '../../content/WaiverFormDescription'
import {WaiverFormHeader} from './WaiverFormHeader'

interface WaiverEditModalFormProps {
  open: boolean
  handleClose: () => void
  selectedTicket?: TicketWaiverModel
  onRefresh?: () => void
}

export const WaiverEditModalForm = ({
  open,
  handleClose,
  selectedTicket,
  onRefresh,
}: WaiverEditModalFormProps) => {
  return (
    <SweetAlert
      containerClassName='p-0'
      customClass={{
        popup: 'bg-black vw-100 vh-100 p-0',
        container: 'p-0 overflow-hidden',
        htmlContainer: 'm-5',
      }}
      open={open}
      onClose={handleClose}
      showConfirmButton={false}
    >
      <div className='w-100 h-100 text-start d-flex flex-column gap-5 digital-waiver-container px-4'>
        <WaiverFormHeader
          arabicTextContent={ARABIC_CONTENT}
          englishTextContent={ENGLISH_CONTENT}
          selectedTicket={selectedTicket}
          handleClose={handleClose}
        />
        <div className='mt-5'>
          <TicketSubmitWaiverFormEdit
            isOpen={open}
            handleClose={handleClose}
            ticket={selectedTicket}
            onRefresh={onRefresh}
          />
        </div>
      </div>
    </SweetAlert>
  )
}
